import { Navigate, useLocation } from 'react-router-dom';

/**
 * NewPasswordRequiredRoute - Protects the new-password-required route
 * Only allows access when redirected from login with NEW_PASSWORD_REQUIRED challenge
 * Redirects to login if accessed directly via URL
 */
export const NewPasswordRequiredRoute = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const location = useLocation();

  // Check if user came from login with the challenge state
  const hasChallengeState =
    location.state?.challengeState ===
    'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED';

  if (!hasChallengeState) {
    // User accessed route directly - redirect to login
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
